import React from 'react';
import SkeletonWrapper from '../../shared/components/skeleton/SkeletonWrapper';

/**
 * @typedef {object} IndustryReportsDescriptionsProps
 * @property {boolean} [isPercentageVisible]
 * @property {boolean} [loading]
 */

/**
 * @param {IndustryReportsDescriptionsProps} props
 */
const IndustryReportsDescriptions = props => {
  const { isPercentageVisible = true, loading = false } = props;

  return (
    <div className='reports-description'>
      <div className='characterization-graph'>
        <SkeletonWrapper show={loading} inheritParentSize={true}>
          <div className='characterization-graph__title-row'>
            <div className='characterization-graph__header'>Practice Characterization</div>
          </div>
          <div className='characterization-graph__description'>
            Displays the cumulative industry characterizations for each practice in the selected PA
            and PGL.
          </div>
        </SkeletonWrapper>
      </div>
      {!loading && isPercentageVisible && (
        <div className='characterization-graph' data-testid='characterization-graph-description'>
          <div className='characterization-graph__title-row'>
            <div className='characterization-graph__header aggregate-header'>
              Aggregate Percentage
            </div>
          </div>
          <div className='characterization-graph__description aggregate-description'>
            Displays the distribution of results (in quintiles) for the Aggregate Percentage of the
            selected PA and PGL.
          </div>
        </div>
      )}
    </div>
  );
};

export default IndustryReportsDescriptions;
